<div class="flex flex-col gap-medpace">
    <medpace-train-details
        id="patientTrainDetails"
        class="w-full"
        [mode]="mode()"
        [formGroup]="formGroup().controls.patientTrainTripDetails"
        [noTravelOption]="false"
    />
    @if (mode() === 'edit' && hasAnyNonDisabledCaregiverControls(this.formGroup().controls.caregivers.controls)) {
        <div>
            <span> Accompanying caregivers: </span>
            @for (caregiverFormGroup of formGroup().controls.caregivers.controls; track caregiverFormGroup) {
                <div class="flex items-baseline">
                    @if (!caregiverFormGroup.disabled) {
                        <mds-expansion-panel
                            id="caregiverTrainDetails_ExpansionPanel"
                            class="expansion-panel-request w-full !border-y-0"
                            [panelTitle]="getCaregiverFullName(caregiverFormGroup.value.caregiver)"
                            [description]="'Book the same train as for the patient'"
                            [disabled]="!!caregiverFormGroup.value.details?.bookIdenticalTrip"
                            [expanded]="!caregiverFormGroup.value.details?.bookIdenticalTrip"
                        >
                            <div class="expansion-panel-checkbox" mds-header-content>
                                <mds-checkbox
                                    id="bookTheSameTrainTrip_Checkbox"
                                    class="w-min"
                                    [formCtrl]="caregiverFormGroup.controls.details.controls.bookIdenticalTrip"
                                />
                            </div>
                            <medpace-train-details
                                class="w-full"
                                [mode]="mode()"
                                [formGroup]="caregiverFormGroup.controls.details.controls.trainDetails"
                            />
                        </mds-expansion-panel>
                    }
                </div>
            }
        </div>
    } @else if (mode() === 'view' && accompanyingCaregivers().length !== 0) {
        <div>
            <span> Accompanying caregivers: </span>
            @for (caregiverFormGroup of accompanyingCaregivers(); track caregiverFormGroup.value.caregiver?.id) {
                <div class="flex items-baseline">
                    <mds-expansion-panel
                        class="expansion-panel-request w-full !border-y-0"
                        [panelTitle]="getCaregiverFullName(caregiverFormGroup.value.caregiver)"
                        [description]="
                            caregiverFormGroup.controls.details.controls.bookIdenticalTrip
                                ? 'The same train was booked as for the patient'
                                : ''
                        "
                        [disabled]="false"
                        [expanded]="false"
                    >
                        <medpace-train-details
                            class="w-full"
                            [mode]="mode()"
                            [formGroup]="caregiverFormGroup.controls.details.controls.trainDetails"
                        />
                    </mds-expansion-panel>
                </div>
            }
        </div>
    }
</div>
